"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _glamor = require("glamor");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _AutoCenter = _interopRequireDefault(require("./AutoCenter"));

var _Composer = _interopRequireDefault(require("./Composer"));

var _Context = _interopRequireDefault(require("./Context"));

var _createBasicStyleSet = _interopRequireDefault(require("./createBasicStyleSet"));

var _Dots = _interopRequireDefault(require("./Dots"));

var _FilmStrip = _interopRequireDefault(require("./FilmStrip"));

var _Flipper = _interopRequireDefault(require("./Flipper"));

var _memoize = _interopRequireDefault(require("./memoize"));

var _ScrollBar = _interopRequireDefault(require("./ScrollBar"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var CAROUSEL_CSS = (0, _glamor.css)({
  overflow: 'hidden',
  position: 'relative'
});

var BasicFilm = /*#__PURE__*/function (_React$Component) {
  _inherits(BasicFilm, _React$Component);

  function BasicFilm(props) {
    var _this;

    _classCallCheck(this, BasicFilm);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BasicFilm).call(this, props));
    _this.createHeightStyle = (0, _memoize.default)(function (height) {
      return {
        height: height
      };
    });
    _this.createBasicStyleSet = (0, _memoize.default)(function (_ref) {
      var autoHide = _ref.autoHide;
      return (0, _createBasicStyleSet.default)({
        autoHide: autoHide
      });
    });
    return _this;
  }

  _createClass(BasicFilm, [{
    key: "render",
    value: function render() {
      var props = this.props;

      var _this$createBasicStyl = _objectSpread({}, this.createBasicStyleSet(props), {}, props.styleSet || {}),
          carousel = _this$createBasicStyl.carousel,
          dotsBox = _this$createBasicStyl.dotsBox,
          dotsItem = _this$createBasicStyl.dotsItem,
          leftFlipper = _this$createBasicStyl.leftFlipper,
          rightFlipper = _this$createBasicStyl.rightFlipper,
          scrollBarBox = _this$createBasicStyl.scrollBarBox,
          scrollBarHandler = _this$createBasicStyl.scrollBarHandler;

      var _props$leftFlipperTex = props.leftFlipperText,
          leftFlipperText = _props$leftFlipperTex === void 0 ? '<' : _props$leftFlipperTex,
          numItems = props.numItems,
          _props$rightFlipperTe = props.rightFlipperText,
          rightFlipperText = _props$rightFlipperTe === void 0 ? '>' : _props$rightFlipperTe,
          scrollBarWidth = props.scrollBarWidth,
          scrolling = props.scrolling,
          _props$showDots = props.showDots,
          showDots = _props$showDots === void 0 ? true : _props$showDots,
          _props$showFlipper = props.showFlipper,
          showFlipper = _props$showFlipper === void 0 ? true : _props$showFlipper,
          _props$showScrollBar = props.showScrollBar,
          showScrollBar = _props$showScrollBar === void 0 ? true : _props$showScrollBar;
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
        className: props.className
      }, _react.default.createElement("div", {
        className: (0, _classnames.default)(CAROUSEL_CSS + '', {
          scrolling: scrolling
        }, carousel + ''),
        style: this.createHeightStyle(props.height)
      }, !!numItems && scrollBarWidth !== '100%' && !!showFlipper && _react.default.createElement(_Flipper.default, {
        className: leftFlipper + '',
        mode: "left"
      }, _react.default.createElement("div", null, leftFlipperText)), _react.default.createElement(_FilmStrip.default, null, props.children), !!numItems && scrollBarWidth !== '100%' && !!showFlipper && _react.default.createElement(_Flipper.default, {
        className: rightFlipper + '',
        mode: "right"
      }, _react.default.createElement("div", null, rightFlipperText)), !!numItems && scrollBarWidth !== '100%' && !!showScrollBar && _react.default.createElement(_ScrollBar.default, {
        className: scrollBarBox + '',
        handlerClassName: scrollBarHandler + ''
      })), !!numItems && scrollBarWidth !== '100%' && !!showDots && _react.default.createElement(_Dots.default, {
        className: dotsBox + '',
        itemClassName: dotsItem + ''
      }, function () {
        return _react.default.createElement("div", null);
      })), props.autoCenter !== false && _react.default.createElement(_AutoCenter.default, null));
    }
  }]);

  return BasicFilm;
}(_react.default.Component);

var _default = function _default(props) {
  return _react.default.createElement(_Composer.default, {
    numItems: _react.default.Children.count(props.children)
  }, _react.default.createElement(_Context.default.Consumer, null, function (_ref2) {
    var numItems = _ref2.numItems,
        scrollBarWidth = _ref2.scrollBarWidth,
        scrolling = _ref2.scrolling;
    return _react.default.createElement(BasicFilm, _extends({}, props, {
      numItems: numItems,
      scrollBarWidth: scrollBarWidth,
      scrolling: scrolling
    }));
  }));
};

exports.default = _default;